import { useEffect, useState } from 'react'
import { fetchSurveyStatus, type SurveyStatus } from '../services/surveys'

export function useSurveyStatus(type: string): SurveyStatus & { loading: boolean; refresh: () => void } {
  const [status, setStatus] = useState<SurveyStatus>({ submitted: false, submittedAt: null })
  const [loading, setLoading] = useState(true)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetchSurveyStatus(type).then((s) => {
      if (!cancelled) {
        setStatus(s)
        setLoading(false)
      }
    })
    return () => { cancelled = true }
  }, [type, tick])

  return { ...status, loading, refresh: () => setTick((t) => t + 1) }
}
